import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { Field, change as changeFieldValue, formValueSelector, reduxForm } from 'redux-form';
import {
    renderFieldCheck,
    renderFieldKM,
    renderFieldNumber,    
    renderFieldSelect,    
    requiredSelect    
} from '../../util/inputs'
import Autorizacao from '../../security/Autorizacao';
import Titulo from '../comum/Titulo';
import { PERFIL_ADMIN } from '../../security/securityContext';
import buscarOpcoesFiltroAdesaoPontos from '../../actions/adesao-pontos/buscarOpcoesFiltroAdesaoPontos';

import cadastrarConfiguracaoPonto from '../../actions/adesao-pontos/cadastrarConfiguracaoPonto';
import { showSuccessMsg } from '../../util/messagesUtil';
import { renderField } from '../../util/arraysUtil';
import selecionarAdesaoPonto from '../../actions/adesao-pontos/selecionarAdesaoPonto';

export class PainelCadastroConfiguracaoPonto extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);        
    }

    componentDidMount() {
        this.props.buscarOpcoesFiltroAdesaoPontos();        
    }

    montarParametros(values) {
        return {
            empresaId: this.props.adesaoPontoSelecionado.id ? this.props.adesaoPontoSelecionado.empresa.id : values.empresa.value.chave,
            peso: values.peso,
            ponto: values.ponto,
            habilitadoGeracaoPontos: values.habilitadoGeracaoPontos,
            habilitadoConsumoPontos: values.habilitadoConsumoPontos
        }
    }
    
    submit(values) {        
        this.props.cadastrarConfiguracaoPonto(this.montarParametros(values))
            .then(() => {                
                showSuccessMsg('A configuração foi salva com sucesso!');
                this.props.history.push('/painel-gerenciar-adesao-pontos');
            });

    }

    render() {
        const { handleSubmit, invalid, submitting } = this.props;

        return (
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN]}>
                <div className='mt-2' style={{ height: '680px' }}>
                    <Titulo texto={`Painel ${this.props.adesaoPontoSelecionado.id != null ? 'Edição' : 'Cadastro'} Pontos`} urlRetorno="/menu-adesao-pontos" />
                    <form onSubmit={handleSubmit(this.submit)}>
                        <fieldset className="scheduler-border">
                            <legend className="scheduler-border">Configurar Pontos</legend>
                            <div className='form-row col-12'>
                                <div className="col-12 col-sm-4 col-md-4">
                                    {!this.props.adesaoPontoSelecionado.id ? <Field name='empresa'
                                        options={this.props.empresas.map(elemento => ({
                                            descricao: `${elemento.chave}-${elemento.valor}`,
                                            nome: elemento
                                        }))}
                                        component={renderFieldSelect}
                                        label="Empresa"
                                        placeholder='Selecione uma empresa' validate={requiredSelect}
                                        />: <div>
                                            <Field name="empresa" type="text" component={renderField}
                                                label="Empresa"                                                
                                                css="form-control" readOnly={true} />
                                        </div>}
                                </div>
                            </div>
                            <div className='form-row col-12'>
                                <div className='col-sm-9 col-md-2'>
                                    <Field name="peso" component={renderFieldKM} label="Peso:"
                                        css="form-control" readOnly={false} />
                                </div>
                                <div className='col-12-col-sm-4 col-md-2'>
                                    <Field name="ponto" type="text" component={renderFieldNumber}
                                        formatacao='#########'
                                        readOnly={false}
                                        label="Pontos:"
                                        css="form-control" />
                                </div>
                            </div>
                            <div className='form-row col-12 mt-3'>
                                <div className="col-12 col-sm-12 col-md-12">
                                    <Field type="checkbox" name='habilitadoGeracaoPontos' component={renderFieldCheck}
                                        label="Ativar/Inativar para Geração de Pontos "
                                        css="form-check-input" readOnly={false}
                                        />
                                </div>
                            </div>
                            <div className='form-row col-12'>
                                <div className="col-12 col-sm-12 col-md-12">
                                    <Field type="checkbox" name='habilitadoConsumoPontos' component={renderFieldCheck}
                                        label="Ativar/Inativar para Consumo de Pontos "
                                        css="form-check-input" readOnly={false}
                                        />
                                </div>
                            </div>
                        </fieldset>
                        <div className=''>
                            <Link className="btn btn-laranja mr-2" to={`${this.props.adesaoPontoSelecionado.id ? '/painel-gerenciar-adesao-pontos' : '/menu-adesao-pontos'}`}>
                                Voltar
                            </Link>
                            <button type="submit"
                                disabled={invalid || submitting}                                
                                className="btn btn-laranja">Salvar
                            </button>
                        </div>
                    </form>
                </div>
            </Autorizacao>
        )
    }
}

export function mapStateToProps(state) {
    return {
        initialValues: {
            empresa: `${state.adesaoPontoSelecionado.empresa.id} - ${state.adesaoPontoSelecionado.empresa.nome}`,
            peso: state.adesaoPontoSelecionado.peso,
            ponto: state.adesaoPontoSelecionado.quantidadePonto,
            habilitadoGeracaoPontos: state.adesaoPontoSelecionado.habilitadoGeracaoPontos,
            habilitadoConsumoPontos: state.adesaoPontoSelecionado.habilitadoConsumoPontos
        },
        empresas: state.opcoesFiltrosAdesaoPontos.empresas,
        habilitadoConsumoPontos: formValueSelector('formularioCadastrarConfiguracaoPontos')(state, 'habilitadoConsumoPontos'),
        adesaoPontoSelecionado: state.adesaoPontoSelecionado
    }
}

export default withRouter(connect(mapStateToProps, {
    buscarOpcoesFiltroAdesaoPontos,
    cadastrarConfiguracaoPonto,
    selecionarAdesaoPonto,
    changeFieldValue
})(reduxForm({
    form: 'formularioCadastrarConfiguracaoPontos',
})(PainelCadastroConfiguracaoPonto)));